(function(){
    'use strict'

    angular
    .module('app.horarios')
    .controller('Horarios', Horarios);

    Horarios.$inject = ['$animationsSrv', 'HorariosService', 'logger', '$location', 'UserInfoService'];

    function Horarios($animationsSrv, HorariosService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.horarios = [];
        vm.title = 'Horarios';

        vm.goToEdit = function(horario){
            
            var path = '/editar-horario/';

            if(horario){
                $location.path(path + horario.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = HorariosService.getAll();

            promise
            .then(function(horarios){
                vm.horarios = horarios;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los horarios.');
                        break;
                }
            });
        };

        vm.delete = function(horario){
            var promise = HorariosService.remove(horario);
            
            promise
            .then(function(response){
                vm.horarios = vm.horarios.filter(function(g) {
                    return g.id !== horario.id;
                });
                logger.success('Horario eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Horario');
                        break;
                }
                
            });   
        };

    }
})();